export default function clipboard() {
  return {
    init() {
      this.originalIcon = this.$refs.icon?.cloneNode(true);
    },

    async copy(content, isHtml = false) {
      try {
        if (isHtml) {
          await this.setClipboardHtml(content);
        } else {
          await window.navigator.clipboard.writeText(content);
        }
        this.setSuccessIcon();
        setTimeout(() => this.setCopyIcon(), 1500);
      } catch {
        this.setFailureIcon();
        setTimeout(() => this.setCopyIcon(), 1500);
      }
    },

    setSuccessIcon() {
      const currentIcon = this.$refs.icon;
      if (!currentIcon) return;
      const successIcon = document.createElement('i');
      successIcon.setAttribute('x-ref', 'icon');
      successIcon.classList.add('icon', 'fa-regular', 'fa-check-double');
      currentIcon.replaceWith(successIcon);
    },

    setFailureIcon() {
      const currentIcon = this.$refs.icon;
      if (!currentIcon) return;
      const failureIcon = document.createElement('i');
      failureIcon.setAttribute('x-ref', 'icon');
      failureIcon.classList.add('icon', 'fa-regular', 'fa-floppy-disk-circle-xmark');
      currentIcon.replaceWith(failureIcon);
    },

    setCopyIcon() {
      const currentIcon = this.$refs.icon;
      if (!currentIcon || !this.originalIcon) return;
      currentIcon.replaceWith(this.originalIcon.cloneNode(true));
    },

    async setClipboardHtml(content) {
      const type = 'text/html';
      const clipboardItemData = {
        [type]: content,
      };
      const clipboardItem = new ClipboardItem(clipboardItemData);
      await navigator.clipboard.write([clipboardItem]);
    },
  };
}
